import React, { useState } from 'react';
import { DIAS_SEMANA, FRANJAS } from '../servicio/SelectorVentanas';

// Horario fijo (16-oct-2026): lugares que solo pueden recibir al técnico a una hora
// exacta ("los jueves a las 13"). Se guarda como ventanas con "hora": [{dia, franja, hora}];
// el backend valida que la hora esté entre las 8 y las 16 y deduce la franja.
export const franjaDeHora = (hora) =>
    FRANJAS.find(f => { const [d, h] = f.id.split('-'); return hora >= d && hora < h; })?.id || null;   // de 8 a 16

export const esHorarioFijo = (ventanas) => Array.isArray(ventanas) && ventanas.some(v => v && v.hora);

export default function HorarioFijo({ value, onChange }) {
    const ventanas = (value || []).filter(v => v.hora);
    const [hora, setHora] = useState(ventanas[0]?.hora || '');
    // Los días elegidos se guardan aparte: así no se pierden si todavía no hay hora
    const [elegidos, setElegidos] = useState(() => new Set(ventanas.map(v => v.dia)));
    const fuera = hora && !franjaDeHora(hora);

    const armar = (dias, h) => {
        const franja = franjaDeHora(h);
        onChange(h && franja ? DIAS_SEMANA.filter(d => dias.has(d.id)).map(d => ({ dia: d.id, franja, hora: h })) : []);
    };
    const alternar = (id) => {
        const n = new Set(elegidos);
        if (n.has(id)) n.delete(id); else n.add(id);
        setElegidos(n);
        armar(n, hora);
    };

    return (
        <div className="space-y-3">
            <p className="text-caption text-muted">Para lugares que solo pueden a una hora exacta. El técnico va ese día a esa hora.</p>
            <div>
                <p className="text-caption font-bold text-secondary mb-1.5">¿Qué días?</p>
                <div className="grid grid-cols-6 gap-1.5">
                    {DIAS_SEMANA.map(d => {
                        const on = elegidos.has(d.id);
                        return (
                            <button key={d.id} type="button" onClick={() => alternar(d.id)} aria-pressed={on}
                                className={`h-10 rounded-xl text-label font-black active:scale-95 ${on ? 'bg-brand-red text-white' : 'bg-chip text-secondary'}`}>{d.corto}</button>
                        );
                    })}
                </div>
            </div>
            <div>
                <p className="text-caption font-bold text-secondary mb-1.5">¿A qué hora?</p>
                <input type="time" value={hora} min="08:00" max="20:00" step={900}
                    onChange={e => { setHora(e.target.value); armar(elegidos, e.target.value); }}
                    className="w-full h-11 px-3.5 rounded-xl bg-chip text-body font-black text-ink outline-none" />
                {fuera && <p className="text-label font-bold text-brand-red mt-1.5">Tiene que ser entre las 8 y las 16 h</p>}
            </div>
            {ventanas.length === 0 && !fuera && (
                <p className="text-label font-bold text-brand-red">⚠ Elegí al menos un día y la hora</p>
            )}
        </div>
    );
}
